import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'auth',
  initialState: {
    adminAuth: false,
    token: '',
    loginError: '',
    loginLoading: false,
  },
  reducers: {
    fetchUserLogin: (state) => {
      let data = localStorage.getItem('adminAuth')
      let token = localStorage.getItem('adminToken')
      const expirationDate = localStorage.getItem('tokenExpiration')

      if (!token || !expirationDate || !data) {
        return { ...state, adminAuth: false, token: '' } // Set to false instead of null
      }

      const now = new Date()
      const expiry = new Date(expirationDate)

      if (now >= expiry) {
        localStorage.removeItem('adminAuth')
        localStorage.removeItem('adminToken')
        localStorage.removeItem('tokenExpiration')
        return { ...state, adminAuth: false, token: '' } // Set to false instead of null
      }

      let parsedData = JSON.parse(data)
      return { ...state, adminAuth: parsedData, token: token } // Return new state object
    },

    userLogin: (state) => {
      state.loginLoading = true
      state.loginError = ''
    },
    userLoginSuccess: (state, { payload: { payload } }) => {
      const now = new Date()
      const expirationDate = new Date(now.getTime() + 5 * 24 * 60 * 60 * 1000)
      let data = JSON.stringify(payload?.data)
      localStorage.setItem('adminAuth', data)
      localStorage.setItem('adminToken', payload.data.access_token)
      localStorage.setItem('tokenExpiration', expirationDate.toISOString())
      state.loginLoading = false
      state.adminAuth = payload.data
      state.token = payload.data.access_token
    },
    userLoginFailed: (state, { payload }) => {
      state.token = ''
      state.loginLoading = false
      state.loginError = payload.message
    },
    adminLogout: (state) => {
      localStorage.removeItem('adminAuth')
      localStorage.removeItem('adminToken')
      localStorage.removeItem('tokenExpiration')
      return { ...state, adminAuth: false, token: '' } // Set to false instead of null
    },
  },
})

export const { adminLogout, fetchUserLogin, userLogin, userLoginFailed, userLoginSuccess } =
  slice.actions

export default slice.reducer
